<template>
  <div>
    <va-card>
      <vue-element-loading :active="visible" :is-full-screen="true" />

      <div class="row">
        <div class="flex md10 sm6 xs12">
          <h4 style="font-size: 24px !important" class="card-title mx-2">
            AVATARS
          </h4>
        </div>
        <div class="flex md2 sm6 xs6 d-flex justify--end">
          <b-button variant="secondary" @click="avatarDialog = true">
            ADD NEW
            <va-icon
              style="font-size: 22px !important"
              name="fa fa-plus-circle"
            />
          </b-button>
        </div>
      </div>
      <div class="flex md12 xs12 sm6">
        <div style="padding-right: 20px !important" class="d-flex justify--end">
          <b-modal
            v-model="avatarDialog"
            size="md"
            centered
            hide-header
            title
            button-size="sm"
            hide-footer
          >
            <form @submit="onSubmit" class="py-2">
              <div>
                <span style="font-weight: 600">Please set Avatar Image </span>
              </div>
              <div class="flex xs12 py-2">
                <output class="pr-3">
                  <img
                    :src="previewUrl"
                    v-if="previewUrl"
                    style="width: 150px; height: 150px"
                  />
                  <p v-else>No image...</p>
                </output>
                <input
                  type="file"
                  required
                  id="file"
                  accept="image/*"
                  v-on:change="uploadImage($event)"
                />
              </div>
              <div class="pt-3">
                <b-button
                  variant="success"
                  class="py-1 px-4"
                  size="md"
                  type="submit"
                  >ADD</b-button
                >
              </div>
            </form>
          </b-modal>
        </div>
      </div>
      <b-row v-if="avatars.length > 0">
        <b-col cols="3" v-for="item in avatars" class="pt-3" :key="item._id">
          <b-card
            v-if="item.icon"
            :img-src="baseURL + item.icon"
            img-alt="Card image"
            img-top
            :img-width="200"
            :img-height="200"
          >
            <b-card-text>
              <b-row align-h="center" class="py-2">
                <b-col cols="6">
                  <b-button
                    @click="
                      (avatarDialog = true),
                        (previewUrl = baseURL + item.icon),
                        (imageId = item._id)
                    "
                    class="px-3 py-1"
                    size="sm"
                    variant="info"
                  >
                    <span>Edit</span>
                  </b-button>
                </b-col>
                <b-col cols="6">
                  <b-button
                    @click="deleteData(item._id)"
                    class="px-3 py-1"
                    size="sm"
                    variant="danger"
                  >
                    <span>Delete</span>
                  </b-button>
                </b-col>
              </b-row>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
      <b-row v-else>
        <span>No Data Found</span>
      </b-row>
    </va-card>
  </div>
</template>
<script>
import axios from "axios";
import VueElementLoading from "vue-element-loading";
export default {
  components: {
    VueElementLoading,
  },
  data() {
    return {
      type: "",
      previewUrl: "",
      visible: false,
      perPage: "15",
      currentPage: 1,
      uname: null,
      msg: "",
      icon: "",
      id: "",
      dat: [],
      data: [],
      avatarDialog: false,
      avatars: [],
      imageId: null,
    };
  },
  mounted: function () {
    this.getList();
  },
  computed: {
    rows() {
      return this.data.length;
    },
  },
  methods: {
    deleteData(val) {
      this.visible = true;
      if (confirm("Are you sure?")) {
        this.visible = true;
        axios({
          method: "POST",

          headers: {
            token: localStorage.getItem("token"),
          },
          url: "/avatar/delete/" + val,
        })
          .then((response) => {
            this.visible = false;
            if (response.data.status) {
              this.getList();
              this.msg = response.data.msg;
              this.$dlg.alert(this.msg, () => {}, { messageType: "success" });
            } else {
              this.msg = response.data.msg;
              this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
            }
          })
          .catch((err) => {
            this.visible = false;
            this.errors.push(err);
            this.$dlg.alert(
              this.msg,
              () => {
                // this.$router.push("/Dashboard");
              },
              { messageType: "error" }
            );
          });
      } else {
        this.visible = false;
        
      }
    },
    uploadImage() {
      this.selectedFile = event.target.files[0];
      this.url = URL.createObjectURL(this.selectedFile);
      const file = event.target.files[0];
      if (file) {
        this.stat = 1;
      } else {
        this.stat = 0;
        return false;
      }
      if (!file.type.match("image.*")) {
        // return false
        this.stat = 0;
      } else {
        this.stat = 1;
      }
      const reader = new FileReader();
      const that = this;
      reader.onload = function (e) {
        that.previewUrl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onSubmit(evt) {
      evt.preventDefault();
      var url;
      let formData = new FormData();
      formData.append("icon", this.selectedFile);
      if (this.imageId) {
        // formData.append("id", this.imageId);
        url = "/avatar/edit/" + this.imageId;
      } else url = "/avatar/add";

      this.visible = true;
      axios({
        method: "post",
        url: url,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.imageId = null;
            this.$bvToast.toast(response.data.msg, {
              title: "status",
              autoHideDelay: 3000,
              variant: "success",
            });
            this.avatarDialog = false;
            this.visible = false;

            this.getList();
          } else {
            this.$bvToast.toast(response.data.msg, {
              title: "status",
              autoHideDelay: 3000,
              variant: "danger",
            });
            this.avatarDialog = false;
            this.getList();
            this.visible = false;
          }
        })

        .catch((e) => {
          console.log(e);
          this.visible = false;
        });
    },
    getList() {
      this.visible = true;
      axios({
        method: "GET",
        url: "/avatar/list",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          // console.log(response.data.data)
          this.data = response.data.data;
          for (var i = 0; i < this.data.length; i++) {
            var dt = this.data[i].create_date;
            dt = new Date(dt);
            dt = dt.toString();
            dt = dt.slice(0, 15);
            this.data[i].create_date = dt;
          }
          if (response.data.status === true) {
            this.avatars = response.data.data;
            this.visible = false;
          } else if (response.data.status === false) {
            this.visible = false;
          }
        })
        .catch((e) => {
          console.log(e);
          this.visible = false;
          this.errors.push(e);
          this.msg = "failed";
        });
    },
  },
};
</script>
<style>
.tablebutto {
  width: 21% !important;
  text-align: left;
}
</style>
